export default {"src":"/_next/static/media/nokia_logo.edbe8862.svg","height":53,"width":313};